<template>
  <div>
    <h3 class="rightTitle" v-if="TopNewsInfos.length >0">专题栏目</h3>
    <ul class="rightUl">
      <li class="wow animate__slideInUp" :key="idx" v-for="(item,idx) in TopNewsInfos">
        <el-image
          class="bookFigure"
          :src="item.PicUrl"
          fit="cover"
        ></el-image>
        <div class="bookBody">
          <h3>
            <span>{{item.Title}}</span>
          </h3>
          <p>{{ item.Summary }}</p>
          <div class="btnBBox">
            <router-link :to="`/newsContent?id=${item.Id}`"><span class="bigMore greyBtn">了解更多</span></router-link>
          </div>
        </div>
        <div class="mask"></div>
      </li>

      
    </ul>
  </div>
</template>

<script>

export default {
  props:["TopNewsInfos"]
};
</script>

<style lang="scss">
.rightTitle {
  font-size: 20px;
  font-weight: 500;
  padding: 0 0 20px 0;
  text-align: center;
}
.rightUl {
  li {
    position: relative;
    background: #f7f7f7;
    overflow: hidden;
    margin-bottom: 20px;
    .mask {
      position: absolute;
      z-index: 1;
      display: none;
      transition: all 0.3s;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.4;
    }
    &:hover {
      .mask {
        display: block;
      }
      .bookBody {
        animation: fadeInDown;
        bottom: 20px;
        animation-duration: 1s;
      }

      h3 {
        color: #fff;
      }
      .bigMore {
        background: #d71820 !important;
        color: #fff;
        border: 1px solid #d71820;
      }
    }
    align-items: flex-start;
    .bookFigure {
      width: 280px;
      height: 370px;
    }
    .bookBody {
      position: absolute;
      left: 20px;
      bottom: 100%;
      display: block;
      width: 240px;
      text-align: left;
      z-index: 9;
      p {
        padding: 10px 0 30px 0;
        color: #fff;
      }
      h3,
      .bookBottom {
        display: flex;
        justify-content: space-between;
      }
      .bookLine {
        border-left: 1px solid #ddd;
        padding-left: 10px;
        overflow: hidden;
      }
      .bookBtn {
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
        border: 1px solid #ddd;
        background: #fff;
      }
    }
    .btnBBox {
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }
}
</style>